module.exports = __webpack_public_path__ + "img/picc.0002e730.png";